import { setTerm } from '@/packages/JsonQuery/helpers';

export const setAccessMode = setTerm('enter');
